import React, { Component } from 'react';
import { Row, Col } from 'react-flexbox-grid';
import {
  Section,
  Heading,
  SectionHeader,
  Paragraph,
  Button,
  AbsoluteCTA,
} from 'components';

class Solution extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isFullDescriptionShown: false,
    };
  }

  toggleHiddenDescription = () =>
    this.setState(prevState => ({
      isFullDescriptionShown: !prevState.isFullDescriptionShown,
    }));

  render() {
    const { isFullDescriptionShown } = this.state;

    return (
      <div className={'development-teams__solution'}>
        <Section color={'gray-light'}>
          <Row className={'no-gap anim-fade-in-bottom'}>
            <Col sm={12} md={6}>
              <SectionHeader
                size={'big'}
                color={'black'}
                lineColor={'red'}
                headingType={2}
              >
                Solution
              </SectionHeader>
            </Col>
            <Col sm={12} md={6}>
              <div className={'development-teams__solution-description'}>
                <Heading color={'black'} size={'medium-plus'} type={3}>
                  Our agile teams of experts have all the competences to
                  understand your business proposition, lay out the best
                  strategy and deliver a product that users want without
                  breaking the bank.
                </Heading>
                {isFullDescriptionShown && (
                  <Paragraph
                    additionalClass={
                      'development-teams__additional-description text--light'
                    }
                    size={'medium'}
                    color={'black'}
                  >
                    We achieve this using a lean approach to product
                    development. Why lean? Because over 42% of startups fail
                    due to a lack of product-market fit. The lean approach
                    helps to eliminate that risk, allowing you to test the
                    market fit of your product at every stage of development
                    with minimum cost and effort.
                  </Paragraph>
                )}
                <div
                  className={'development-teams__learn-more-button'}
                  onClick={this.toggleHiddenDescription}
                >
                  <Button order={'secondary'} arrowColor={'red'}>
                    {isFullDescriptionShown ? 'Show less' : 'Learn more'}
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </Section>
        <AbsoluteCTA id={'page-development-teams-solution'} />
      </div>
    );
  }
}

export default Solution;
